import React, { useCallback, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux';
import Alert from "react-s-alert";
/********** COMPONENTS **********/
import LoadingSpinner from "component/LoadingSpinner";
import Header from './Header/index';
import Footer from './Footer2';
import Menu from './Menu';
/********** REDUX **********/
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
/********** SERVICES **********/
import ApiServices from "service/ApiServices";
/********** STYLES **********/
import './style.css';

const Home = (props) => {
/********** VARIABLES **********/
    const dataOPRedux = props.dataOP;
    const [currentUser] = useState(props.currentUser);
    const [loadingSpinner, setLoadingSpinner] = useState({openLoading: false, message: ''});

/********** FUNCTIONS **********/
    const getOpData = useCallback(async () => {
        try {
            setLoadingSpinner({...loadingSpinner, openLoading: true, message: 'Obteniendo datos de la Organización...'});
            const hasPermission = await ApiServices.userSecurity.hasPermission("informacionGeneralMiOrganizacionPolitica","list");
            if (hasPermission.error) {
                setLoadingSpinner({...loadingSpinner, openLoading: false})
                Alert.error(hasPermission.error);
            } else {        
                const response = await ApiServices.informacionGeneralMiOrganizacion.list();
                if (response.error !== null) {
                    Alert.error(response.error.message);
                } else if (response.data !== "") {
                    props.INFORMATION_OP_SET_DATA(response.data);
                }
                setLoadingSpinner({...loadingSpinner, openLoading: false});
            }
        } catch (exception) {
            exception.status === 404 ? Alert.warning("Intente de nuevo") : Alert.warning("Intente de nuevo ");
            setLoadingSpinner({...loadingSpinner, openLoading: false});
        }
    },[]);

    useEffect(() => {
        if(currentUser){
            if(currentUser.rol.name === "Organizaciones Políticas"){
                if((Object.keys(dataOPRedux).length === 0)){
                    getOpData();
                }
            }
        }
    }, [getOpData, currentUser]);

/********** RENDER **********/
    if(!props.authenticated){
        return <Redirect
            to={{
                pathname: "/login",
                state: { from: props.location, authenticated: props.authenticated }
            }}/>;
    } else {
        return (
            <div className="colorPagePrincipal">
                {loadingSpinner.openLoading && <LoadingSpinner open={loadingSpinner.openLoading}
                     message={loadingSpinner.message}/>}
                <Header/>
                <Menu/>
                <div className= "separateDiv">
                <Footer/> 
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
/* 

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {  loading: false, 
                        authenticated: props.authenticated,
                        location: this.props.location
                    }
    }
  
    componentDidMount() { this.setState({loading: false }); }
    
    render() {
        if (!this.state.authenticated){ 
            return <Redirect
                to={{
                    pathname: "/login",
                    // pathname: "/PageInMaintenance",
                    state: { from: this.props.location, authenticated: this.state.authenticated }
                }}/>;
            }

        if (this.state.loading) return (<LoadingIndicator></LoadingIndicator>)
        else return (
            <div className="colorPagePrincipal">
                <Header/>
                <Menu/>
                <div className= "separateDiv">
                <Footer/> 
                </div>
            </div>
        )
    }
}
export default Home; */